const questionSelectors = {
    editingQuestionId: state => state.question.editingQuestionId,
    editingCategoryId: state => state.question.editingCategoryId,
    showChangesHistoryDrawer: state => state.question.showChangesHistoryDrawer,
    showCreateCategoryDrawer: state => state.question.showCreateCategoryDrawer,
    showCompareWithLmsDrawer: state => state.question.showCompareWithLmsDrawer,
    showCreateQuestionDrawer: state => state.question.showCreateQuestionDrawer,
}

export default questionSelectors
